import React, { useState } from "react";
import styled from "@emotion/styled";
import { setColor } from "../../../../../assets/styles/styles";
import { default as Button } from "../../../../../components/common/button/Button";
import Typography from "../../../../../components/common/text/Typography";

const JsonViewerModal = ({ jsonEditorValue, action, handleJsonSave, fieldName, label, closeModal }) => {
    const [textVal, setTextVal] = useState(
        typeof jsonEditorValue === "string" ? jsonEditorValue : JSON.stringify(jsonEditorValue, null, 2)
    );
    const [errorText, setErrorText] = useState("");

    const handleSave = () => {
        try {
            if (fieldName === "passwords" || fieldName === "products") {
                try {
                    const parsedData = JSON.parse(textVal);
                    if (Array.isArray(parsedData)) {
                        setErrorText("");
                        handleJsonSave(parsedData, fieldName);
                        closeModal();
                    } else {
                        setErrorText(`Invalid format for ${fieldName}. It should be an array.`);
                    }
                } catch (err) {
                    setErrorText(`Invalid format for ${fieldName}. It should be an array.`);
                }
            }
            if (
                fieldName === "linkoutPayload" ||
                fieldName === "videoPayload" ||
                fieldName === "dynamicLinkouts" ||
                fieldName === "panelPromptText" ||
                fieldName === "coordinates" ||
                fieldName === "freeFormJson" ||
                fieldName === "freeformJson" ||
                fieldName === "ssoMetadataJson" || 
                fieldName === "otherConfig" || 
                fieldName === "clientTagMeta" ||
                fieldName === "metaData" ||
                fieldName === "triggerValue" 
            ) {
                try {
                    const parsedData = JSON.parse(textVal);
                    if (typeof parsedData === "object") {
                        setErrorText("");
                        handleJsonSave(parsedData, fieldName);
                        closeModal();
                    }
                } catch (err) {
                    setErrorText(`Invalid format for ${fieldName}. It should be an JSON format.`);
                }
            }
        } catch (err) {
            console.log(err);
            setErrorText("Invalid format. Please correct it.");
        }
    };

    return (
        <>
            <Typography variant="h2PurpleHeading" margin={`0 0 20px 0`}>
                {fieldName !== "frames" && fieldName !== "forms" && fieldName !== "subroomRoomIds" ? (
                    <>Edit Data for {label}</>
                ) : (
                    <>View Data for {label}</>
                )}
            </Typography>

            <Card>
                <TEXTAREA
                    value={textVal}
                    onChange={(e) => setTextVal(e.target.value)}
                    style={{ width: "100%", height: "300px" }}
                />
                {errorText && <MessageDesc>{errorText}</MessageDesc>}

                {fieldName !== "frames" && fieldName !== "forms" && fieldName !== "subroomRoomIds" && (
                    <>
                        <Button
                            buttonWidth={"30%"}
                            label={action === "Update" ? "Update" : "Add"}
                            margin={"1rem 5rem 1rem 5rem"}
                            onClick={handleSave}
                        />

                        <Button
                            buttonWidth={"30%"}
                            label={"Cancel"}
                            margin={"1rem 5rem 1rem 0rem"}
                            onClick={closeModal}
                        />
                    </>
                )}
            </Card>
        </>
    );
};

export default JsonViewerModal;

const Card = styled.div`
    height: auto;
    position: relative;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const TEXTAREA = styled.textarea`
    border: 1px solid ${setColor.grey1};
    border-radius: 5px;
    color: ${setColor.inputText};
    width: 100%;
    background-color: transparent;
`;

const MessageDesc = styled.div`
    font-size: 14px;
    color: ${setColor.errorColor};
    margin: 0.5rem 0rem 0rem 0rem;
`;
